var _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360.37 145.68",
    style: {
      enableBackground: "new 0 0 360.37 145.68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\n.st0{fill:url(#SVGID_1_);}\n\n.st1{fill:url(#SVGID_2_);}\n\n.st2{fill:url(#SVGID_3_);}\n\n.st3{fill:url(#SVGID_4_);}\n\n.st4{fill:url(#SVGID_5_);}\n\n.st5{fill:url(#SVGID_6_);}\n\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.506,
    y1: 72.84,
    x2: 358.8644,
    y2: 72.84
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBBD59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E99725"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.34,52.45c-0.07,0.03-0.14,0.06-0.2,0.1c-0.28,0.13-0.55,0.28-0.82,0.43c-0.2,0.11-0.39,0.22-0.58,0.33 c-0.15,0.09-0.29,0.19-0.44,0.28c-0.25,0.16-0.49,0.32-0.72,0.49c-0.1,0.08-0.2,0.16-0.31,0.24c-0.25,0.2-0.5,0.4-0.74,0.61 c-0.09,0.08-0.18,0.17-0.27,0.25c-0.24,0.22-0.47,0.45-0.7,0.69c-0.08,0.09-0.15,0.18-0.23,0.26c-0.23,0.26-0.45,0.53-0.66,0.81 c-0.02,0.03-0.05,0.05-0.07,0.08c-0.42,0.57-2.65,2.62-2.65,8.59c0,0.62,0,1.35,0,2.17c0,2.26,0-1.7,0.01,1.56 c0,1.18,0,2.41,0,3.65c0,0.31,0,0.62,0,0.94c0,0.94,0,1.88,0,2.82c0,0.31,0,0.63,0,0.94c0,1.88,0.01,3.75,0.01,5.54 c0,0.59,0,1.18,0,1.75c0,2.5-1.28,4.71-3.24,6.07c-1.23,0.85-2.72,1.37-4.34,1.41h-11.07c-0.04,0-0.07,0-0.1,0 c-5.14,0-7.26,1.62-7.26,1.62v-1.6h-0.02v-6.29c0.01-0.25,0.01-0.49,0.02-0.74v-0.86l0.01,0V1.41c0,0,0,0,0,0l-4.59,0.66 c-8.96,1.29-14.31,6.84-14.31,14.86c0,4.93,0.02,58.87,0.03,68.05c0.01,3.59-2.63,6.58-6.15,7.31H274.5v-7.76l0,0l0.03-13.98 c0-11.49-5.8-17.95-10.67-21.34c-5.64-3.93-12.18-5.33-16.43-5.34c-0.71-0.01-4.6-0.01-4.64-0.01c-11.24,0-27.95,7.09-27.95,26.63 v12.82c0,1.61,0.15,3.1,0.4,4.48c0.32,1.75,0.79,3.32,1.34,4.67c0,0-9.26,0-9.71,0c-0.01,0-0.03,0-0.04,0h-1.68 c-0.23,0.02-0.47,0.04-0.75,0.04c-5.14,0-7.26,1.62-7.26,1.62v-0.42v-9.08v-7.36l-0.01,0V50.01c-2.04,0.08-6.47,0.44-10.52,2.36 c-0.07,0.03-0.14,0.06-0.2,0.1c-0.28,0.13-0.55,0.28-0.82,0.43c-0.2,0.11-0.39,0.22-0.58,0.33c-0.15,0.09-0.29,0.19-0.44,0.28 c-0.25,0.16-0.49,0.32-0.72,0.49c-0.1,0.08-0.2,0.16-0.31,0.24c-0.25,0.2-0.5,0.4-0.74,0.61c-0.09,0.08-0.18,0.17-0.27,0.25 c-0.24,0.22-0.47,0.45-0.7,0.69c-0.08,0.09-0.15,0.18-0.23,0.26c-0.23,0.26-0.45,0.53-0.66,0.81c-0.02,0.03-0.05,0.05-0.07,0.08 c-0.42,0.57-2.65,2.62-2.65,8.59c0,0.62,0,1.35,0,2.17c0,1.44,0,3.17,0,5.07c0,0.54,0,1.1,0,1.67c0,0.57,0,1.16,0,1.75 c0,1.04,0,8.06,0,9.14c-0.09,1.93-0.94,3.66-2.27,4.94c-1.37,1.31-3.26,2.14-5.34,2.18h-10.87c-0.16,0.01-0.32,0.02-0.5,0.02 c-5.14,0-7.26,1.62-7.26,1.62v-0.42v-8.09l-0.01,0c0-0.08,0-0.16,0.01-0.24V84.6l0,0V50.01c-2.04,0.08-6.47,0.44-10.52,2.36 c-0.07,0.03-0.14,0.06-0.2,0.1c-0.28,0.13-0.55,0.28-0.82,0.43c-0.2,0.11-0.39,0.22-0.58,0.33c-0.15,0.09-0.29,0.19-0.44,0.28 c-0.25,0.16-0.49,0.32-0.72,0.49c-0.1,0.08-0.2,0.16-0.31,0.24c-0.25,0.2-0.5,0.4-0.74,0.61c-0.09,0.08-0.18,0.17-0.27,0.25 c-0.24,0.22-0.47,0.45-0.7,0.69c-0.08,0.09-0.15,0.18-0.23,0.26c-0.23,0.26-0.45,0.53-0.66,0.81c-0.02,0.03-0.05,0.05-0.07,0.08 c-0.42,0.57-2.65,2.62-2.65,8.59c0,0.62,0,1.35,0,2.17c0,2.26,0,11.18,0.01,14.43c0,1.05,0,2.13,0,3.22 c-0.02,0.29-0.05,0.57-0.09,0.85c-0.6,3.52-3.77,6.2-7.61,6.25h-2.37h-2.12c-4.68,0.13-6.63,1.61-6.63,1.61v-9.5l0.04,0v-3.8V62.95 l-4.59,0.66c-8.96,1.29-14.31,6.84-14.31,14.86c0,4.93,0.02-2.68,0.03,6.49c0.01,4.11-3.45,7.45-7.73,7.5H75.05l0.02-23.22 l-4.58,0.66c-8.98,1.29-14.35,6.84-14.35,14.87c0,4.36,0-2.79,0.01,3.02c0.01,14.1,0.03,24.17,0.03,29.41 c0,5.24-4.35,9.18-9.62,9.18c-5.27,0-11.25,0-16.61,0c-5.36,0-9.62-4.11-9.62-9.19c0-5.08,0.18-31.77,0.18-32.9 c0-0.46-0.02-0.9-0.06-1.34c-0.57-7.2-5.78-12.07-14.18-13.13l-4.49-0.56L1.76,73.6L1.7,82.95L1.51,117.2 c0,3.89,0.76,11.31,5.84,17.63c3.44,4.28,10.08,9.39,22.13,9.39l17.51,0.06c12.09,0,18.74-5.11,22.19-9.4 c5.1-6.33,5.86-13.77,5.86-17.63l0-1.97c0-2.59,2.11-4.7,4.78-4.86c0.08,0,0.2,0,0.34,0c-0.07,0-0.14-0.01-0.2-0.01 c0.02,0,0.04,0,0.07,0c0.27,0,0.65,0,1.14,0c-0.39,0.01-0.74,0.01-1.01,0.01c0.47,0.02,1.14,0.06,1.39,0.07 c2.91,0.09,5.64,0.04,8.12-0.08c7.04,0,17.08,0,27.93,0c-0.13,0-0.26,0-0.39,0c-0.07,0-0.1,0-0.1,0c0,0.01,0.14,0.01,0.37,0.01 c-0.1-0.01-0.19-0.01-0.25-0.01c0.25,0,0.71,0,1.36,0c-0.45,0.01-0.84,0.01-1.11,0.01c1.07,0.05,4.35,0.23,8.64-0.01 c8.95,0,23.18,0,36.55,0c-0.16,0-0.32,0.01-0.49,0.01c0.02,0,0.05,0,0.08,0c0.05,0,0.12,0,0.22,0c1.03,0,2.35,0,2.94,0 c12.06,0,54.46,0,76.66-0.01c-0.19,0-0.37,0.01-0.56,0.01c0.15,0,0.44,0,0.84,0c0,0,0,0,0,0c0.23,0,0.51,0,0.82,0 c1.04,0,2.51,0,4.33,0c0.16,0,0.31,0,0.47,0c0,0,0,0,0,0c6.93,0,18.57,0,31.31,0c-0.13,0-0.25,0-0.38,0c-0.07,0-0.1,0-0.1,0 c0,0.01,0.14,0.01,0.37,0.01c-0.1-0.01-0.19-0.01-0.25-0.01c0.25,0,0.71,0,1.36,0c-0.45,0.01-0.84,0.01-1.11,0.01 c1.07,0.05,4.35,0.23,8.64-0.01c10.81,0,29.32,0,44.73-0.01c14.53,0,26.3-11.28,26.3-25.18V50.09 C356.82,50.17,352.4,50.52,348.34,52.45z M133.14,85.1c0-1.49,0-2.52,0-1.87c0,0.59,0,1.18,0,1.75 C133.15,85.02,133.14,85.06,133.14,85.1z M178.27,85.14c0-1.03,0.01-1.83,0.01-0.16C178.28,85.04,178.27,85.09,178.27,85.14z M255.9,86.29c0,3.84-3.25,6.95-7.26,6.95h-7.98c-5.14,0-7.26,1.62-7.26,1.62v-8.57v-0.93V68.47c0-3.84,3.25-6.95,7.26-6.95h7.98 c4.01,0,7.26,3.11,7.26,6.95V86.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.6696,
    y1: 127.7774,
    x2: 324.2592,
    y2: 127.7774
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4C172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0AE42"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.96,116.27c-6.78,0-12.29,5.16-12.29,11.5c0,6.34,5.52,11.5,12.29,11.5c6.78,0,12.29-5.16,12.29-11.5 C324.26,121.43,318.74,116.27,311.96,116.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.0985,
    y1: 26.1686,
    x2: 243.688,
    y2: 26.1686
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBBD59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E99725"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M231.39,14.66c-6.78,0-12.29,5.16-12.29,11.5c0,6.34,5.52,11.5,12.29,11.5c6.78,0,12.29-5.16,12.29-11.5 C243.69,19.82,238.17,14.66,231.39,14.66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.3353,
    y1: 26.1686,
    x2: 269.925,
    y2: 26.1686
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBBD59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E99725"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M257.63,14.66c-6.78,0-12.29,5.16-12.29,11.5c0,6.34,5.52,11.5,12.29,11.5c6.78,0,12.3-5.16,12.3-11.5 C269.92,19.82,264.41,14.66,257.63,14.66z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.6043,
    y1: 127.7774,
    x2: 211.1939,
    y2: 127.7774
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBBD59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E99725"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M198.9,116.27c-6.78,0-12.29,5.16-12.29,11.5c0,6.34,5.52,11.5,12.29,11.5c6.78,0,12.29-5.16,12.29-11.5 C211.19,121.43,205.68,116.27,198.9,116.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.6379,
    y1: 127.7774,
    x2: 184.2275,
    y2: 127.7774
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBBD59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E99725"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M171.93,116.27c-6.78,0-12.29,5.16-12.29,11.5c0,6.34,5.52,11.5,12.29,11.5c6.78,0,12.29-5.16,12.29-11.5 C184.23,121.43,178.71,116.27,171.93,116.27z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.569c9b25482f1b2088d4af991d46848a.svg";
export { ForwardRef as ReactComponent };